export default "__VITE_ASSET__B1z7swJg__"